<template>
    <v-dialog v-model="dialog" fullscreen persistent>
        <v-card style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <div class="d-flex align-center ga-2">
                    <v-btn
                        v-if="selectedFile"
                        size="small"
                        variant="outlined"
                        color="white"
                        prepend-icon="mdi-microsoft-edge"
                        @click="openInEdge()"
                    >
                        Open in Edge
                    </v-btn>
                    <v-btn
                        v-if="selectedFile"
                        size="small"
                        variant="text"
                        color="white"
                        prepend-icon="mdi-open-in-new"
                        @click="openInNewTab()"
                    >
                        New Tab
                    </v-btn>
                    <v-btn flat icon color="darkGreen" @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <div v-if="selectedFile" style="height: 100%;">
                    <iframe
                        :src="`${serverUrl}/compliance-upload/stream-file/${selectedFile}`"
                        type="application/pdf"
                        width="100%"
                        height="100%"
                        style="border: none; border-radius: 12px;"
                    ></iframe>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Close" variant="outlined" elevation="1" @click="dialog = false"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
    data () {
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            loading: false,

            serverUrl: process.env.VUE_APP_SERVER_URL,
            selectedFile: null,
        }
    },
    methods: {
        getStreamUrl(file) {
            return `${this.serverUrl}/compliance-upload/stream-file/${encodeURIComponent(file)}`
        },
        viewFile(data){
            this.dialog = true
            this.dialog_title = 'View File'
            this.dialog_sub_title = data
            this.selectedFile = data
        },
        openInNewTab() {
            if (!this.selectedFile) {
                return
            }

            window.open(this.getStreamUrl(this.selectedFile), '_blank', 'noopener')
        },
        openInEdge() {
            const { showSnackbar } = useSnackbar()

            if (!this.selectedFile) {
                return
            }

            const fileUrl = this.getStreamUrl(this.selectedFile)

            try {
                window.location.href = `microsoft-edge:${fileUrl}`
                showSnackbar('Attempting to open the PDF in Microsoft Edge. If blocked, use New Tab.', 'success')
            } catch (error) {
                window.open(fileUrl, '_blank', 'noopener')
                showSnackbar('Microsoft Edge could not be opened directly. The PDF was opened in a new tab instead.')
            }
        }
    }
})
</script>

<style scoped>

</style>